'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.65 0a3.435 3.435 0 0 1 3.45 3.429 3.435 3.435 0 0 1-3.45 3.428A3.435 3.435 0 0 1 9.2 3.43 3.435 3.435 0 0 1 12.65 0m8.05 14.857c0-2.697-2.104-5.028-5.175-6.148-.575.948-1.656 1.577-2.875 1.577a3.45 3.45 0 0 1-3.174-2.092 5.133 5.133 0 0 0-.77.137L5.75 6.857V9.51C4.025 10.537 2.817 12 2.438 13.714H0v4.572h3.542a7.828 7.828 0 0 0 2.208 1.92V24h2.3v-2.789c1.07.32 2.231.503 3.45.503 1.219 0 2.38-.183 3.45-.503V24h2.3v-3.794c1.323-.777 2.334-1.852 2.921-3.063H23v-2.286h-2.3M5.75 13.714a1.15 1.15 0 0 1-1.15-1.143 1.15 1.15 0 0 1 2.3 0 1.15 1.15 0 0 1-1.15 1.143Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var PiggyBank = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.PiggyBank = PiggyBank;